import { Link as LinkS } from "react-scroll";
import styled from "styled-components";
import { COLORS } from "../const/colors";

export const Button = styled(LinkS)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: ${COLORS.ORANGE};
  color: ${COLORS.WHITE};
  padding: 0.85rem 1.5rem;
  border-radius: 0.75rem;
  font-weight: 500;
  font-size: 1rem;
  transition: all 0.3s ease;
  cursor: pointer;
  box-shadow: 0 4px 10px ${COLORS.ORANGE_30};
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      90deg,
      transparent,
      ${COLORS.WHITE_30},
      transparent
    );
    transition: all 0.6s ease;
  }

  &.hero_ghost {
    background-color: transparent;
    border: 2px solid ${COLORS.ORANGE};
    color: ${COLORS.ORANGE};
    box-shadow: 0 4px 8px ${COLORS.ORANGE_20};
  }

  &:hover {
    background-color: ${COLORS.DARK_BLUE};
    transform: translateY(-3px);
    box-shadow: 0 6px 15px ${COLORS.DARK_BLUE_30};

    &::before {
      left: 100%;
    }
  }

  &:active {
    transform: translateY(-1px);
    box-shadow: 0 4px 8px ${COLORS.ORANGE_30};
  }

  &.hero_ghost:hover {
    background-color: ${COLORS.ORANGE_10};
    border-color: ${COLORS.DARK_BLUE};
    color: ${COLORS.DARK_BLUE};
  }
`;
